import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/pending/translation.revert.mutation.gql"
import type {
  TranslationRevertMutation,
  TranslationRevertMutationVariables,
} from "@/v2-backoffice-client/translation/pending/__types__/translation.revert.mutation"

type Options = MutationHookOptions<
  TranslationRevertMutation,
  TranslationRevertMutationVariables
>

export function useTranslationRevertMutation(options?: Options) {
  return useMutation<
    TranslationRevertMutation,
    TranslationRevertMutationVariables
  >(mutation, {
    // Reverting changes both the pending changelog and the catalog values.
    refetchQueries: ["TranslationChangesQuery", "TranslationCatalogQuery"],
    ...options,
  })
}
